import React from "react";
import "./DropDownList.scss";
import { DropDownList as KendoDropDownList } from "@progress/kendo-react-dropdowns";

const DropDownList = (props) => {
  const className = props.className
    ? `${props.className} instream-drop-down-list`
    : "instream-drop-down-list";

  const handleChange = (item) => {
    props.onChange(item);
  };

  const handleOpen = () => {
    if (props.reference && dropDownList) {
      props.reference(dropDownList);
    }
  };

  let dropDownList = null;

  return (
    <div className={className}>
      <KendoDropDownList
        {...props}
        label={props.label}
        data={props.data}
        textField={props.textField ? props.textField : null}
        dataItemKey={props.dataItemKey ? props.dataItemKey : null}
        value={props.value}
        required={props.required}
        onChange={handleChange}
        onOpen={handleOpen}
        ref={component => dropDownList = component}
      />
    </div>
  );
};

export default DropDownList;
